import { clsx } from "clsx";

import { customTwMerge } from "./customTv";

export function cn(...args: (string | undefined)[]): string {
  return customTwMerge(clsx(...args));
}
